// extracted by mini-css-extract-plugin
module.exports = {"container-small":"ForbiddenToCreator_container-small__JoKEc","center-vertical":"ForbiddenToCreator_center-vertical__HBjSN"};